import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData, trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import moment from 'moment';
import { onSelectedApprover, resetApprover } from './new-circuit/new-circuit-subscription.reducer';
import {
    //model
    wirelineChangeVendorModel
    //action
    , resetWirelineChangeVendorForm
    , setVendorOptions
    , setAccountOptions
    , setVendorDetails
    , setSubscriptionDetails
    , setFormSubmitted
    , setCountryName
    , setResetLoading
    , setResetApprover
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-change-vendor.settings';

export const changeVendorModelAInitialState = wirelineChangeVendorModel;

const defaultState = () => ({
    accountOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , vendorDetails: {
        Currency: ''
    }
    , subscription: {}
    , formSubmitted: false
    , countryName: 'USA'
    , isResetLoading: false
    , isResetApprover: false
});

const initialState = defaultState();


export const wirelineChangeVendorActions = {
    onUpdateForm:() => async (dispatch, state) => {

        const { selectedItem, requestData } = state().requestDetail;
        const { subscriptionList, employeeList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { countryName } = state().wirelineChangeVendorRequest;

        await updateSubscriptionSelect(requestData.Circuit.CircuitCode, subscriptionList, dispatch, state);
        await getAccounts(dispatch, requestData.NewRequest.Vendor.VendorDetailId);
        await updateOnEmployeeSelect(requestData.WireLineApprover.LastName + ", " + requestData.WireLineApprover.FirstName, employeeList, dispatch, state);
        dispatch(actions.change('wirelineChangeVendorFormA.vendorDetailId', requestData.NewRequest.Vendor.VendorDetailId.toString()));
        dispatch(actions.change('wirelineChangeVendorFormA.financeAccountId', requestData.NewRequest.Account.FinanceAccountId.toString()));
        dispatch(actions.change('wirelineChangeVendorFormA.needByDate', new Date(requestData.Order.NeedByDate)));
        dispatch(actions.change('wirelineChangeVendorFormA.expediteRequest', requestData.BusinessWireline.ExpediteRequest.toString()));
        dispatch(actions.change('wirelineChangeVendorFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
        dispatch(actions.change('wirelineChangeVendorFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));


    },
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineChangeVendorFormA } = state().form;
        const { countryName } = state().wirelineChangeVendorRequest;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        let countrySelected=countryName;

        if(isRequestOnBehalf) {
            countrySelected=requestOnBehalfData.Country;
        }

        if (value === '') {
            resetForm(dispatch);
            dispatch(actions.change('wirelineChangeVendorFormA.employeeName', ''));
            dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', 0));
            dispatch(onSelectedApprover(''))
            dispatch({ type: setResetApprover, data: true });
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
           if(objects) {
               var obj = objects.find(o => o[propsName] === value);
             
            if (obj != null && obj.CircuitId != wirelineChangeVendorFormA.circuitId) {
                dispatch(actions.reset('wirelineChangeVendorFormA.circuitCode'));
                dispatch(actions.reset('wirelineChangeVendorFormA.circuitId'));
                resetForm(dispatch);
                dispatch(actions.change('wirelineChangeVendorFormA.circuitCode', value));
                dispatch(actions.change('wirelineChangeVendorFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
                dispatch(actions.change('wirelineChangeVendorFormA.employeeName', ''));
                dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', 0)); 
                dispatch(onSelectedApprover(''))
                dispatch({ type: setResetApprover, data: true });
                getVendors(dispatch, obj, countrySelected);
            }
           }
        }
    }
    , onVendorSelect: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineChangeVendorFormA.financeAccountId', 0));

        //Clear options
        dispatch({ type: setAccountOptions, data: [] });
        dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });

        //fetch new data options
        getAccounts(dispatch, value);
    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineChangeVendorFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineChangeVendorFormA.employeeName', ''));
            dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', 0));
            dispatch(onSelectedApprover(''));
            dispatch({ type: setResetApprover, data: true });
        } else {
            const obj = objects?.find(o => o[propsName] === value);

            if (obj != null) {
                if (parseInt(obj.EmployeeId) !== parseInt(wirelineChangeVendorFormA.wireLineApproverId)) {
                    dispatch(actions.change('wirelineChangeVendorFormA.employeeName', value));
                    dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', obj.EmployeeId));
                }           
                dispatch(onSelectedApprover(value, obj.EmployeeId));
                setTimeout(function () {
                    dispatch({ type: setResetApprover, data: false });
                }, 5)
            }

        }
    }
    , onChangeExpedite: (model, value) => (dispatch) => {

        dispatch(actions.change(model, value));

        if (!trueFalseToBoolean(value)) {
            dispatch(actions.change('wirelineChangeVendorFormA.businessJustification', ''));
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineChangeVendorFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { requestData, isAmending } = state().requestDetail;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , wirelineChangeVendorRequest: {
                ...wirelineChangeVendorFormA
                , requestInBehalfId: userData.requestInBehalfId
                , needDate: wirelineChangeVendorFormA.needByDate ? moment(wirelineChangeVendorFormA.needByDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
            }
            , ChangeRequestModel: {
                ...userData
                , ...wirelineChangeVendorFormA
                , CircuitId: wirelineChangeVendorFormA.circuitCode ? wirelineChangeVendorFormA.circuitId : 0
                , vendorDetailId: wirelineChangeVendorFormA.vendorDetailId ? wirelineChangeVendorFormA.vendorDetailId : 0
                , BusinessJustification: wirelineChangeVendorFormA.businessJustification
                , AdditionalInformation: wirelineChangeVendorFormA.additionalInformation
                , RequestTypeId: requestTypeId
                , NoEmail: true
            }
            , User: { ...userData }
            , IsAmending: isAmending
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , CircuitId: isAmending ? requestData.CircuitId : 0
            , CircuitOrderId: isAmending ? requestData.CircuitOrderId : 0
            , OrderHistoryId: isAmending ? requestData.OrderHistoryId : 0
            , OrderInfoId: isAmending ? requestData.OrderInfoId : 0
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelineChangeVendorForm: (isResetRequestOnBehalf = false) => (dispatch,state) => {
        resetForm(dispatch); 
        dispatch(actions.reset('wirelineChangeVendorFormA.circuitCode'));
        if(isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelineChangeVendorFormA.employeeName'));
            dispatch(actions.reset('wirelineChangeVendorFormA.wireLineApproverId'));
            dispatch(actions.reset('wirelineChangeVendorFormA'));
            dispatch(onSelectedApprover(''))
            dispatch({ type: setResetApprover, data: true });
            dispatch({ type: setSubscriptionDetails, data: {} });      
            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 1);
        }  
    }
    , setCountryName: (value) => (dispatch, state) =>{
        dispatch({ type: setCountryName, data: value });
    }


}

async function updateOnEmployeeSelect(value, employeeList, dispatch, state) {

    const obj = employeeList?.find(o => o.LastFirstName === value);

    if (obj != null) {
        dispatch(actions.change('wirelineChangeVendorFormA.employeeName', obj.Name || value));
        dispatch(actions.change('wirelineChangeVendorFormA.wireLineApproverId', obj.EmployeeId));
        dispatch(onSelectedApprover(value, obj.EmployeeId));
        dispatch({ type: setResetApprover, data: false });
    }
}

async function updateSubscriptionSelect(circuitCode, subscriptionList, dispatch, state){

    const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
    const { countryName } = state().wirelineChangeVendorRequest;

    let countrySelected = countryName;

    if(isRequestOnBehalf) {
        countrySelected=requestOnBehalfData.Country;
    }

    var obj = subscriptionList.find(o => o["CircuitCode"] === circuitCode);

    dispatch(actions.change('wirelineChangeVendorFormA.circuitCode', circuitCode));
    dispatch(actions.change('wirelineChangeVendorFormA.circuitId', obj?.CircuitId));
    dispatch({ type: setSubscriptionDetails, data: obj });
    getVendors(dispatch, obj, countrySelected);
    

}

async function getAccounts(dispatch, id) {
    var res = await httpGet('external/orderRequest/getAccountByVendor/' + id);

    if (res != null) {
        dispatch({ type: setAccountOptions, data: res });
    } else {
        dispatch({ type: setAccountOptions, data: [] });
    }
}

async function getVendors(dispatch, obj, country) {
    if (obj === undefined || obj == null) return;

    var res = await httpGet('external/changeVendor/getVendors/'
        + obj.CircuitId + '/'
        + country + '/'
        + obj.VendorDetailId);

    if (res != null && res.ok !== false) {
        dispatch({
            type: setVendorOptions,
            prefVendors: res.Vendors
        });
    } else {
        dispatch({
            type: setVendorOptions,
            prefVendors: []
        });
    }
}

function resetForm(dispatch) {
    dispatch({ type: setResetLoading, data: true });
    dispatch(actions.reset('wirelineChangeVendorFormA'));
    dispatch(actions.reset('wirelineChangeVendorFormA.employeeName'));
    dispatch(actions.reset('wirelineChangeVendorFormA.wireLineApproverId'));
    dispatch({ type: resetWirelineChangeVendorForm, vendor: defaultState.vendorDetails });
    dispatch({ type: setSubscriptionDetails, data: {} });  
    dispatch({ type: setFormSubmitted, data: false });
    dispatch(onSelectedApprover(''))
    setTimeout(function () {
        dispatch({ type: setResetLoading, data: false });
    }, 5);
    dispatch({ type: setFormSubmitted, data: false });
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case resetWirelineChangeVendorForm:
            return {
                ...state,
                accountOptions: []
                , preferredVendorOptions: []
                , nonPrefVendorOptions: []
                , vendorDetails: { ...action.vendor }
            };
        case setVendorOptions:
            return {
                ...state
                , preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setAccountOptions:
            return {
                ...state
                , accountOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state
                , vendorDetails: { ...action.data }
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setCountryName: 
            return {
                ...state
                , countryName: action.data
            }
        case setResetLoading:
                return {
                    ...state
                    , isResetLoading: action.data
            }
        case setResetApprover:
            return {
                ...state
                , isResetApprover: action.data
            }

        default: return state;
    }
}